import React from "react";
import { authRoles } from "../../modules/utils/RouteAuth";

export const TeamConfig = {
  settings: {
    layout: {
      config: {
        header: { display: true },
        footer: { display: true },
        navbar: { display: true }
      }
    }
  },
  isPrivate: true,
  auth: authRoles.team,
  routes: [
    {
      path: "/team",
      component: React.lazy(() => import("./index"))
    }
  ]
};
